<template>
  <div class="documents-status-container left">
    <span >{{statusLabel}}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserState } from '@/store';
import { Status } from '@/utils/useData';

export default {
  computed: {
    ...mapState(['LANG']),
    ...mapBrowserState([
      'totalDocumentsCount',
      'documentsStatus',
    ]),
    statusLabel() {
      // Pluralize the word entries
      // Note: this can be done with the pluralize module, but for now it doesn't make sense to add it
      let messageResolved = `${this.totalDocumentsCount} ${this.LANG.entriesFound}.`;
      if (this.totalDocumentsCount === 1) {
        messageResolved = `${this.totalDocumentsCount} ${this.LANG.entryFound}.`;
      }

      return {
        [Status.IDLE]: '',
        [Status.RESOLVED]: messageResolved,
        [Status.LOADING]: `${this.LANG.loading}...`,
        [Status.ERROR]: this.LANG.documentCountError,
      }[this.documentsStatus];
    },
  },
};
</script>

<style scoped lang='scss'>
  .documents-status-container {
    padding-left: 10px;
    color: #191919;
    font-size: 0.6875em;
    font-weight: normal;
    letter-spacing: 1px;
  }
</style>
